import { Button } from "theme-ui";
import { IoClose } from "react-icons/io5";

export const ExitButton = ({ onClose }) => {
  return (
    <Button
      type="button"
      variant="ghost"
      onClick={onClose}
      aria-label="Close"
      sx={{
        p: 2,
        m: 0,
        minWidth: "auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 0,
      }}
    >
      <IoClose size={22} />
    </Button>
  );
};
